import { AsyncStatus } from '@monetize/types/common';
import { useCallback, useEffect, useState } from 'react';

export function useAsyncStatus(resetDelay = 2000, minLoadingDuration = 400) {
  const [status, setStatus] = useState<AsyncStatus>('idle');

  useEffect(() => {
    if (status === 'success' || status === 'error') {
      const timer = setTimeout(() => setStatus('idle'), resetDelay);
      return () => clearTimeout(timer);
    }
  }, [status, resetDelay]);

  const track = useCallback(
    async (fn: () => Promise<void>) => {
      setStatus('loading');
      const minWait = new Promise<void>((resolve) =>
        setTimeout(resolve, minLoadingDuration),
      );
      try {
        await Promise.all([fn(), minWait]);
        setStatus('success');
      } catch {
        await minWait;
        setStatus('error');
      }
    },
    [minLoadingDuration],
  );

  return { status, track };
}
